// extracted by mini-css-extract-plugin
module.exports = {"mailchimp":"MailChimpWrapper-module--mailchimp--320DX"};